import { FormattedMessage } from "react-intl";
import childrenDiaryEndingAudio from "@/assets/audios/children-diary-ending.m4a";
import MediaPlayer from "@/components/ui/media-player.tsx";
import { Button } from "@/components/ui/button";
import { useNavigate } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";
import { ExerciseLayout } from "@/components/ui/exercise-layout";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/diary-children/completionView"
)({
  component: () => <CompletionView />,
  head: () => ({
    meta: [
      {
        title: "Writing a Diary - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "weakness.exercises.diary",
  }),
});

export default function CompletionView() {
  const navigate = useNavigate();

  const handleAnotherExerciseClick = () => {
    navigate({ to: "/children/exercises" });
  };

  const handleBackClick = () => {
    navigate({ to: "/children/exercises/diary-children" });
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <>
          <Button onClick={handleAnotherExerciseClick} className="w-full">
            <FormattedMessage id="diary.children.tryanotherexercise" />
          </Button>
          <Button
            onClick={handleBackClick}
            className="w-full"
            variant="secondary"
          >
            <FormattedMessage id="diary.children.back" />
          </Button>
        </>
      }
    >
      <p className="text-sm leading-relaxed">
        <FormattedMessage id="diary.children.completion.description" />
      </p>

      <MediaPlayer src={childrenDiaryEndingAudio} />
    </ExerciseLayout>
  );
}
